import { Card } from '@/components/ui/card';
import { useTranslation } from 'react-i18next';
import { Wish } from '../wish';
import { List } from '@/features/List/list';
import useGetUser from '@/features/User/hooks/useGetUser';

type WishCardProps = {
	wish: Wish;
	list: List;
	onClick?: () => void;
};

const WishCard = ({ wish, onClick, list }: WishCardProps) => {
	const { t } = useTranslation();
	const { user } = useGetUser();
	const renderImage = () => {
		if (wish.image_key) {
			return (
				<img
					src={`${import.meta.env.VITE_API_URL}/image?imageKey=${wish.image_key}`}
					alt={wish.name}
					className="h-14 w-14 rounded-md object-cover"
				/>
			);
		} else {
			return <div className="h-14 w-14 rounded-md bg-gray-200" />;
		}
	};

	return (
		<Card
			onClick={onClick}
			className="flex w-full max-w-md cursor-pointer items-center gap-6 rounded-lg p-4 shadow-sm transition-shadow hover:shadow-md "
		>
			{renderImage()}
			<div className="grid flex-1 gap-2">
				<h3 className="line-clamp-2 font-bold">{wish.name}</h3>
				<div className="flex items-center justify-between">
					{!!wish.price && (
						<div className="text-sm opacity-80">{wish.price}€</div>
					)}
					{!!wish.fk_user_reserved && list.fk_user !== user?.id && (
						<div className="rounded-md bg-primary px-2 py-1 text-xs font-medium text-primary-foreground">
							{t('wish.reserved')}
						</div>
					)}
				</div>
			</div>
		</Card>
	);
};

export default WishCard;
